export const useScoreColorTreshold = (color: string) => {
    const formattedColor = color.toLowerCase()
    if (formattedColor === 'green') {
        return '1'
    }
    if (formattedColor === 'yellow') {
        return '2'
    }
    if (formattedColor === 'orange') {
        return '3'
    }
    if (formattedColor === 'red') {
        return '4'
    }
    return '5'
}
